// Photographs for the chooser's answers: step → answer → picture. An answer with no photo
// here falls back to its line drawing (components/shop/LockPictos). Every photo except the
// two big first-step doors is prepared at 4:3 (1200×900 + a 600×450 "-sm") and shown whole,
// never zoomed in (Hugh, 24 Sep 2026). `pos` is the CSS object-position for the big cards.
//
// Hardware photos are per door material (Hugh, 24 Sep 2026: an aluminium door must not be
// shown timber-door hardware): onDoor → aluminium | timber → key, files <key>-alu / <key>-timber.
// A missing combination shows the drawing. Free-licence photos only (Pexels / Unsplash /
// Wikimedia Commons), credits in public/images/shop/SOURCES.json under "chooser"; Hugh's own
// job photos replace any of them.
//
// onDoor keys: mortice · multipoint · deadbolt · lever · nightlatch · gripset · none · other
// material keys: aluminium · timber · unsure
const photo = (file, alt) => ({ src: `/images/shop/chooser/${file}.jpg`, sm: `/images/shop/chooser/${file}-sm.jpg`, alt });

const chooserMedia = {
  slides: {
    slides: { src: '/images/shop/chooser/slides.jpg', sm: '/images/shop/chooser/slides-sm.jpg', alt: 'Aluminium sliding door open onto a deck', pos: '72% 50%' },
    swings: { src: '/images/shop/chooser/swings.jpg', sm: '/images/shop/chooser/swings-sm.jpg', alt: 'Timber hinged front door' },
  },
  material: {
    aluminium: photo('aluminium', 'Slim dark aluminium-framed glass doors'),
    timber: photo('timber', 'Stained timber front door'),
  },
  onDoor: {
    aluminium: {
      mortice: photo('mortice-alu', 'Lever on a narrow backplate with the key cylinder below, on an aluminium door'),
    },
    timber: {
      mortice: photo('mortice-timber', 'Lever handle with a separate keyhole below it, on a timber door'),
      deadbolt: photo('deadbolt-timber', 'Round key deadbolt above a separate lever, on a timber door'),
      gripset: photo('gripset-timber', 'Black entrance gripset with a deadbolt above it, on a timber door'),
    },
  },
};

// `answers` picks the hardware photo for the door material chosen in step 2; a door of
// unsure material gets the drawings.
const mediaFor = (step, value, answers = {}) => {
  const byStep = chooserMedia[step];
  if (!byStep) return null;
  if (step === 'onDoor') return (byStep[answers.material] && byStep[answers.material][value]) || null;
  return byStep[value] || null;
};

module.exports = { chooserMedia, mediaFor };
